import { IMaskInput } from 'react-imask';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FormControl from '@mui/material/FormControl';
import { useFormik } from 'formik';
import { InputAdornment, OutlinedInput } from '@mui/material';
import { forwardRef } from 'react';

type HandleChangeType = Pick<ReturnType<typeof useFormik>, 'handleChange'>;

const TextMaskCustom = forwardRef<HTMLElement, HandleChangeType>(function TextMaskCustom(
  props,
  ref
) {
  const { handleChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask='##:m#:m#'
      definitions={{
        '#': /[0-9]/,
        m: /[0-5]/,
      }}
      onAccept={handleChange}
      overwrite
      inputRef={ref as never}
    />
  );
});

export default function Timepicker({ value, handleChange }: { value: string } & HandleChangeType) {
  return (
    <FormControl fullWidth>
      <OutlinedInput
        size='small'
        value={value}
        onChange={handleChange}
        endAdornment={
          <InputAdornment position='end'>
            <AccessTimeIcon />
          </InputAdornment>
        }
        name='startOffset'
        inputComponent={TextMaskCustom as never}
      />
    </FormControl>
  );
}
